// import $ from "jquery";

// import script accordingly
// import "./themes/header/_header"; 
import "./themes/components/_components"; 
import "./themes/widget/_widget"

